import React from 'react';
import {PageNavigation, RenderOnlyFor} from '@ignitesales/neuro-application';
import LandingPage from './pages/LandingPage.jsx';
import SurveyPage from './pages/SurveyPage.jsx';
import SummaryPage from './pages/SummaryPage.jsx';
import PageMessage from "./PageMessage.jsx";
import StarterProgressBar from "./StarterProgressBar.jsx";
import {scrollToTop, DialogueThemeContainer, DialoguePageContainer, LoadingDataIcon} from "../../../../../../shared/js";
import DialogueProgressBar from "../../../../../../shared/js/core-components/DialogueProgressBar";
import BasicHeader from "../../../../../../shared/js/core-components/BasicHeader";

const App = () => {
    return <DialogueThemeContainer>
        <BasicHeader/>
        <DialoguePageContainer
            LandingPage={LandingPage}
            SurveyPage={SurveyPage}
            SummaryPage={SummaryPage}
            DetailsPage={SummaryPage}
        />
        <RenderOnlyFor forSurveyPage={true}>
            <div className="navigationBar">
                <LoadingDataIcon />
                <div className="navigationBar__box">
                    <DialogueProgressBar ProgressBarComponent={StarterProgressBar} />
                </div>
                <PageMessage />
                <PageNavigation onNextPageClicked={ scrollToTop } onPreviousPageClicked={ scrollToTop } />
            </div>
        </RenderOnlyFor>
    </DialogueThemeContainer>;
};

export default App;
